module.exports = __webpack_public_path__ + "img/bg.a96d9397.jpg";